import React from 'react';
import { CircularProgress, Button, Grid } from '@material-ui/core';
import styled from 'styled-components';

const StyledButtonList = styled.div`
  display: flex;
  justify-content: ${props =>
  props.withPrevStep ? 'space-between' : 'flex-end'};
  flex: 1;
  border-top: 1px solid #dcdcdc;
  padding: 15px 60px;
  margin-top: 50px;
  @media (max-width: 600px) {
    padding: 15px 20px;
  }
`;

const stepControl = ({ isLoading, nextStep, prevStep, nextLabelText = "Next" }) => (
  <Grid item xs={12}>
    <StyledButtonList withPrevStep={nextStep || prevStep}>

      {prevStep && (
      <Button
        variant='contained'
        color='secondary'
        onClick={prevStep}
      >
         Back
      </Button>
      )}

      {nextStep && (
      <Button variant="contained" color="secondary" onClick={nextStep}>
        Skip
      </Button>
)}

      <div>
        {isLoading && <CircularProgress />}
        {!isLoading && (
        <Button variant="contained" color="primary" type="submit">
          {nextLabelText}
        </Button>
      )}
      </div>

    </StyledButtonList>
  </Grid>
);

export default stepControl;
